module.exports = __webpack_public_path__ + "img/clover.3e9eadd1.svg";